<div
  class="primary-bg-color main-wrapper"
  role="dialog"
  aria-modal="true"
  aria-labelledby="modal-title"
  [ngClass]="{'colapsed':colapsed}"
>
  <div *ngIf="!colapsed" class="right-container">
    <div>
      <fts-loading-indicator class="selection-text-color spinner" *ngIf="!imageLoaded"></fts-loading-indicator>
      <img (load)="imageLoadedEvent()" [src]="imgSrc" alt="Coupons Image">
    </div>
  </div>
  <div class="left-container-wrapper" [ngClass]="{'left-container-wrapper-colapsed':colapsed}">
    <div #smsModalLeftContainer class="left-container" [ngClass]="{'colapsed':colapsed}" tabindex="0">
      <fa-icon class="selection-text-color" (click)="close()" [attr.aria-label]="'component.sms_sub_promo_modal.close' | translate" [icon]="faXmark" role="button" tabindex="0" (keydown.enter)="close()" (keydown.space)="close()"></fa-icon>
      <div class="header">
        <h1 id="modal-title" class="modal-title">
        {{translateService.instant('component.sms_sub_promo_modal.title')}}
        </h1>
        <h2 #couponTitle class="coupon-title text-uppercase">
          {{title}}
        </h2>
        <fts-sms-offer-description *ngIf="description" [description]="description"></fts-sms-offer-description>
        <span class="details primary-text-color">
          {{translateService.instant('component.sms_sub_promo_modal.purchase_info')}}
        </span>
      </div>

      <section class="main-content" role="region" [attr.aria-label]="'component.sms_sub_promo_modal.component.sms_sub_promo_modal.sms_subscription_form' | translate">
        <form id="smsForm" [ftsAriaForm]="form" [formGroup]='form' #profileform="ngForm" novalidate>
          <div *ngIf="!isUserInstantiated" class="input-wrapper">
            <label class="sr-only" for="sms-modal-name">Name:</label>
            <input [ngClass]="{'error': errors?.name?.length}" id="sms-modal-name" formControlName="name"  type="text" placeholder="Name" style="margin-top: 0 !important;"
            [attr.aria-describedby]="(errors?.name) | generateIds : 'sms-subscription-name-error'"
            >
            <div class="error-text-space-keep">
              <span id="sms-subscription-name-error-{{i}}" class="error-text has-error" *ngFor="let error of errors?.name; let i = index;">{{error}}</span>
            </div>
          </div>
          <div *ngIf="!isUserInstantiated" class="input-wrapper">
            <label class="sr-only" for="sms-modal-email">Email:</label>
            <input  [ngClass]="{'error': errors?.email?.length}" id="sms-modal-email" formControlName="email"  type="text" placeholder="Email"  [attr.aria-describedby]="(errors?.email) | generateIds : 'sms-subscription-email-error'">
            <div class="error-text-space-keep">
              <span id="sms-subscription-email-error-{{i}}" class="error-text has-error" *ngFor="let error of errors?.email; let i = index;">{{error}}</span>
            </div>
          </div>
          <div class="input-wrapper">
            <label class="sr-only" for="sms-modal-phone">Phone:</label>
            <input  [ngClass]="{'error': errors?.phone?.length}" id="sms-modal-phone" formControlName="phone"  [textMask]="{mask: phoneMask}" type="text" placeholder="Mobile Number" [attr.aria-describedby]="(errors?.phone) | generateIds : 'sms-subscription-phone-error'">
            <div class="error-text-space-keep">
              <span id="sms-subscription-phone-error-{{i}}" class="error-text has-error" *ngFor="let error of errors?.phone; let i = index;">{{error}}</span>
            </div>
          </div>
          <div *ngIf="isUserInstantiated && !account.phone" class="input-wrapper">
            <label class="sr-only" for="sms-modal-password">Password:</label>
            <input  [ngClass]="{'error': errors?.password?.length}" id="sms-modal-password" formControlName="password"   type="password" placeholder="Current Password" [attr.aria-describedby]="(errors?.password) | generateIds : 'sms-subscription-password-error'">
            <div class="error-text-space-keep">
              <span id="sms-subscription-password-error-{{i}}" class="error-text has-error" *ngFor="let error of errors?.password; let i = index;">{{error}}</span>
            </div>
          </div>
          <div class="input-wrapper">
            <fts-themeable-checkbox
              formControlName="emailSubscription"
              [name]="'emailSubscription'"
              [ariaLabel]="'route.checkout.checkout_details.contact_information.customer_subscription_form.subscribe_email_offers_full' | translate">
              {{'route.checkout.checkout_details.contact_information.customer_subscription_form.subscribe_email_offers_full' | translate}}
            </fts-themeable-checkbox>
          </div>
          <footer class="fotter-wrapper" [ngClass]="{'fotter-wrapper-logedin':isUserInstantiated}">
            <fts-sms-sign-up-information></fts-sms-sign-up-information>
            <button
              type="submit"
              form="smsForm"
              role="button"
              ftsAsyncButton
              [subscription]="loadingSub"
              (click)="submitClicked()"
              class="action-bg-color action-inverse-text-color submit-btn font-secondary"
              [attr.aria-label]="'component.sms_sub_promo_modal.component.sms_sub_promo_modal.subscribe_to_sms_promo' | translate"
            >
              {{translateService.instant('component.sms_sub_promo_modal.subscribe_btn')}}
            </button>
            <button (click)="noThanksClicked()" class="primary-bg-color primary-text-color font-secondary">
              {{translateService.instant('component.sms_sub_promo_modal.no_thanks_btn')}}
            </button>
          </footer>
        </form>
      </section>
    </div>
  </div>
</div>
